import Axios from '@/utils/axios';
import { clearSessionCaches } from '@/utils/sessionReset';
import { storage } from '@/utils/storage';

const AuthService = {
  login: async (firebaseToken: string) => {
    try {
      const data = { token: firebaseToken };
      const response = await Axios.post('/v1/auth/user/login', data);
      const backendToken = response.data.data.token;

      storage.setItem('token', backendToken);

      return backendToken;
    } catch (error: any) {
      throw error;
    }
  },

  logout: () => {
    clearSessionCaches();
    storage.clear();

    if (window.location.pathname !== '/signin') {
      window.location.href = '/signin';
    }
  },

  getToken: () => {
    return storage.getItem('token');
  },

  isAuthenticated: () => {
    return !!AuthService.getToken();
  },
};

export default AuthService;
